import cn from 'classnames';
import { FC } from 'react';
import useLocalization from 'src/services/localization/useLocalization';
import { useAppConfig } from 'src/utils/appConfig/useAppConfig';
import { styles } from './NovaPoshtaSeoText.styles';

export interface NovaPoshtaSeoTextProps {
  withTopMargin?: boolean
}

const NovaPoshtaSeoText: FC<NovaPoshtaSeoTextProps> = props => {
  const { chain } = useAppConfig();
  const { withTopMargin } = props;
  const localize = useLocalization();
  const content = localize(`seotext_nova_poshta_${chain}`);

  return (
    <div className={cn(
      'NovaPoshtaSeoText', {
        'NovaPoshtaSeoText_withTopMargin': withTopMargin,
    })}
      data-marker='Seo Text Nova Poshta'
    >
      <p className='NovaPoshtaSeoText__content'>{content}</p>
      <style jsx>{styles}</style>
    </div>
  );
};

export default NovaPoshtaSeoText;
